import { render, staticRenderFns } from "./inventory-list.vue?vue&type=template&id=1d380aff&scoped=true&"
import script from "./inventory-list.vue?vue&type=script&lang=js&"
export * from "./inventory-list.vue?vue&type=script&lang=js&"
import style0 from "./inventory-list.vue?vue&type=style&index=0&id=1d380aff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d380aff",
  null
  
)

export default component.exports